import React, { useState } from 'react';
import { Zap, Shield, Headphones, Settings,  ArrowRight, Users, Globe, Award } from 'lucide-react';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';
import DedicatedPackages from '../../components/navbar/internet/internet-dedicated/produk';

import Footer from '../../components/footer/index';

const InternetDedicated = () => {
  const { isDarkMode } = useDarkMode();
  const [selectedPackage, setSelectedPackage] = useState(1); // Default ke paket populer

  const dedicatedFeatures = [
    {
      icon: <Zap className="w-8 h-8" />,
      title: "High Bandwidth",
      description: "Nikmati bandwidth tinggi yang tidak dibagi dengan pengguna lain",
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Reliability",
      description: "Koneksi dengan uptime SLA 99.9%",
      color: "from-green-500 to-green-600"
    },
    {
      icon: <Headphones className="w-8 h-8" />,
      title: "Support 24/7",
      description: "Tim teknis tersedia 24 jam untuk mendukung operasional bisnis Anda",
      color: "from-purple-500 to-purple-600"
    },
    {
      icon: <Settings className="w-8 h-8" />,
      title: "Customizable",
      description: "Layanan dapat disesuaikan dengan kebutuhan khusus bisnis Anda",
      color: "from-orange-500 to-orange-600"
    }
  ];

  const dedicatedPackages = [
    {
      name: "Starter",
      price: "5.000.000",
      speed: "50 Mbps",
      features: [
        "Dedicated bandwidth",
        "SLA 99.9% uptime",
        "24/7 technical support",
        "Free setup & installation"
      ],
      popular: false,
      color: "from-blue-500 to-blue-600"
    },
    {
      name: "Most Popular",
      price: "9.000.000", 
      speed: "100 Mbps",
      features: [
        "Premium dedicated bandwidth",
        "SLA 99.9% uptime",
        "Priority technical support",
        "Backup line redundancy"
      ],
      popular: true,
      color: "from-blue-600 to-blue-700"
    },
    {
      name: "Enterprise",
      price: "Custom",
      speed: "500+ Mbps",
      features: [
        "Custom bandwidth",
        "Advanced security firewall", 
        "Dedicated account manager",
        "Monitoring real-time"
      ],
      popular: false,
      color: "from-gray-600 to-gray-700"
    }
  ];

  const testimonials = [
    {
      name: "PT. Teknologi Maju",
      role: "IT Director",
      rating: 5,
      comment: "Sejak menggunakan internet dedicated NetSpeedPro, produktivitas kantor meningkat signifikan. Koneksi stabil dan support yang responsif.",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop&crop=face"
    },
    {
      name: "Bank Syariah Mandiri",
      role: "Network Administrator", 
      rating: 5,
      comment: "Keamanan dan reliability yang tinggi membuat kami percaya untuk menggunakan layanan dedicated ini untuk operasional perbankan.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop&crop=face"
    },
    {
      name: "Rumah Sakit Prima",
      role: "IT Manager",
      rating: 5,
      comment: "Untuk sistem informasi rumah sakit yang kritis, kami membutuhkan koneksi yang sangat stabil. NetSpeedPro memberikan exactly yang kami butuhkan.",
      avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=60&h=60&fit=crop&crop=face"
    }
  ];

  const businessBenefits = [
    {
      icon: <Globe className="w-12 h-12" />,
      title: "Skalabilitas Tinggi",
      description: "Mudah untuk upgrade bandwidth sesuai pertumbuhan bisnis Anda"
    },
    {
      icon: <Award className="w-12 h-12" />,
      title: "SLA Terjamin",
      description: "Komitmen uptime 99.9% dengan kompensasi jika tidak tercapai"
    },
    {
      icon: <Users className="w-12 h-12" />,
      title: "Dedicated Support",
      description: "Tim teknis khusus yang memahami infrastruktur bisnis Anda"
    }
  ];

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900' : 'bg-white'
    }`}>

      
      
      {/* Hero Section */}
      <section
        className={`py-20 px-4 relative overflow-hidden ${
          isDarkMode
            ? 'bg-gray-900'
            : 'bg-[#dfe4e0ff]'
        } bg-cover bg-center`}
        style={{
          backgroundImage: "url('https://telnet.net.id/assets/bg.png')", // ganti dengan path gambar kamu
          backgroundBlendMode: "overlay",
        }}
      >
        {/* Overlay tipis */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1E9B4C]/20 to-green-700/20"></div>

        <div className="container mx-auto relative z-10 mb-20 text-center mt-24"> {/* Menambahkan margin top */}
          <h1
            className={`text-4xl md:text-6xl font-bold mb-12 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}
          >
            INTERNET DEDICATED
          </h1>

          <p
            className={`text-xl md:text-2xl max-w-4xl mx-auto mb-8 leading-relaxed ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}
          >
            Layanan internet dedicated dengan bandwidth tinggi yang tidak dibagi dengan
            pengguna lain. Stabil, handal dan cocok untuk mendukung operasional bisnis Anda.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://wa.me/6287778882022" target="_blank" rel="noopener noreferrer">
            <button className="bg-[#1E9B4C] text-white hover:bg-green-700 font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg">
              Konsultasi Gratis
            </button>
            </a>
            <button className="border-2 border-[#1E9B4C] text-[#1E9B4C] hover:bg-[#1E9B4C] hover:text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105">
              Lihat Paket
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section
        className={`py-16 px-4 relative overflow-hidden ${
          isDarkMode ? 'bg-gray-800' : 'bg-[#dfe4e0ff]'
        } bg-cover bg-center`}
        style={{
          backgroundImage: "url('https://telnet.net.id/assets/bg.png')", // ganti sesuai path gambar
          backgroundBlendMode: "overlay",
        }}
      >
        {/* overlay tipis */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1E9B4C]/10 to-green-700/10"></div>

        <div className="container mx-auto relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {dedicatedFeatures.map((feature, index) => (
              <div
                key={index}
                className={`text-center p-6 rounded-xl transition-all duration-300 hover:scale-105 shadow-lg ${
                  isDarkMode
                    ? 'bg-gray-700 hover:bg-gray-600 border border-gray-600'
                    : 'bg-white hover:bg-green-50 border border-gray-200'
                }`}
              >
                {/* Icon Wrapper */}
                <div
                  className={`bg-gradient-to-br ${feature.color || 'from-[#1E9B4C] to-green-700'} w-16 h-16 rounded-lg flex items-center justify-center text-white mx-auto mb-4`}
                >
                  {feature.icon}
                </div>

                {/* Title */}
                <h3
                  className={`text-xl font-bold mb-3 ${
                    isDarkMode ? 'text-white' : 'text-gray-900'
                  }`}
                >
                  {feature.title}
                </h3>

                {/* Description */}
                <p
                  className={`leading-relaxed ${
                    isDarkMode ? 'text-gray-300' : 'text-gray-600'
                  }`}
                >
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <DedicatedPackages />
      {/* Business Benefits */}
     
     <section
      className={`py-16 px-4 relative overflow-hidden ${
        isDarkMode ? "bg-gray-800" : ""
      }`}
      style={{
        backgroundImage: isDarkMode
          ? "url('https://telnet.net.id/assets/bg.png')"
          : "url('https://telnet.net.id/assets/bg.png')",
        backgroundColor: isDarkMode ? "#111827" : "#dfe4e0ff",
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay tipis */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#dfe4e0ff]/30 to-[#dfe4e0ff]/10"></div>

      <div className="container mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2
            className={`text-3xl font-bold mb-4 ${
              isDarkMode ? "text-white" : "text-gray-900"
            }`}
          >
            Keunggulan untuk Bisnis Anda
          </h2>
          <p
            className={`text-xl ${
              isDarkMode ? "text-gray-300" : "text-gray-600"
            }`}
          >
            Mengapa memilih internet dedicated untuk bisnis
          </p>
        </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {businessBenefits.map((benefit, index) => (
              <div
                key={index}
                className={`text-center p-6 rounded-xl transition-all duration-300 hover:scale-105 shadow-lg ${
                  isDarkMode ? "bg-gray-700/80" : "bg-white/90"
                }`}
              >
                <div
                  className="flex justify-center mb-4"
                  style={{ color: " #1E9B4C" }}
                >
                  {benefit.icon}
                </div>
                <h3
                  className={`text-xl font-bold mb-3 ${
                    isDarkMode ? "text-white" : "text-gray-900"
                  }`}
                >
                  {benefit.title}
                </h3>
                <p className={isDarkMode ? "text-gray-300" : "text-gray-600"}>
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
      className={`py-16 px-4 relative overflow-hidden ${
        isDarkMode ? "bg-gray-900" : ""
      }`}
      style={{
        backgroundColor: isDarkMode ? "#111827" : " #1E9B4C",
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* overlay tipis */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#1E9B4C]/30 to-green-700/20"></div>

      <div className="container mx-auto text-center text-white relative z-10">
        <h2 className="text-4xl font-bold mb-4">
          Siap Upgrade Internet Bisnis Anda?
        </h2>
        <p className="text-xl mb-8 max-w-3xl mx-auto opacity-90">
          Hubungi tim kami untuk mendapatkan solusi internet dedicated terbaik
          sesuai kebutuhan bisnis Anda
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="https://wa.me/6283848581998" target="_blank" rel="noopener noreferrer">
          <button className="bg-white text-[#1E9B4C] hover:bg-gray-100 font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg">
            Konsultasi Sekarang
            <ArrowRight className="w-5 h-5 inline-block ml-2" />
          </button>
          </a>
          <a href="https://wa.me/6283848581998" target="_blank" rel="noopener noreferrer">
          <button className="border-2 border-white text-white hover:bg-white hover:text-[#1E9B4C] font-semibold px-8 py-4 rounded-lg transition-all duration-300">
            Hubungi Sales
          </button>
          </a>
        </div>
      </div>
    </section>
    <Footer />
    </div>
  );
};

export default InternetDedicated;